export const SET_MINI = 'SET_MINI';
export const TOGGLE_MINI = 'TOGGLE_MINI';
export const SET_CUSTOM_MENU_ITEM = 'SET_CUSTOM_MENU_ITEM';
export const TOGGLE_MENU_ITEM = 'TOGGLE_MENU_ITEM';
export const INIT_NAVIGATION_RULES = 'INIT_NAVIGATION_RULES';
export const SET_DISABLED_ITEMS = 'SET_DISABLED_ITEMS';
export const REMOVE_MENU_ITEM = 'REMOVE_MENU_ITEM';
export const UPDATE_MENU_ORDER = 'UPDATE_MENU_ORDER';
export const SAVE_NAVIGATION_RULES = 'SAVE_NAVIGATION_RULES';